import axios from 'axios';
import { TimelineMax } from 'gsap';
import React, { Component } from 'react';
import Col from 'react-bootstrap/lib/Col';
import Image from 'react-bootstrap/lib/Image';
import Row from 'react-bootstrap/lib/Row';
import Title from '../objs/Title';
import './Contact.css';
let back = 'https://backend.themusiccompany.dk';

class Agent extends Component {
  handleClick(e) {
    this.props.newAgent(this.props.obj);
  }

  render() {
    return (
      <div onClick={this.handleClick.bind(this)} className="agentDiv">
        <Image
          className="face"
          alt={this.props.obj.name}
          responsive
          src={this.props.obj.prof_img.thumbnail}
        />
      </div>
    );
  }
}

class ActiveAgent extends Component {
  render() {
    return (
      <Col md={12} lg={6}>
        <div className="agentBig">
          <div className="activeFace">
            <img
              className="faceImg"
              alt={this.props.obj.name}
              responsive
              src={this.props.obj.prof_img.big}
            />
          </div>
          <div className="agentBigText">
            <p className="activeagentName">{this.props.obj.name}</p>
            <p className="activeagentPosition">{this.props.obj.position}</p>
            <p className="activeagentEmail">
              <a href={'mailto:' + this.props.obj.email}>
                {this.props.obj.email}
              </a>
            </p>
            <p className="activeagentPhone">
              <a href={'tel:' + this.props.obj.phone}>{this.props.obj.phone}</a>
            </p>
          </div>
        </div>
      </Col>
    );
  }
}

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agents: [],
      firstagent: [],
      imgs: [],
    };
  }

  setAgent(obj, THIS) {
    THIS.setState({ firstagent: <ActiveAgent obj={obj} key={obj.id} /> });
  }

  hideAgent({ target, options }) {
    var bigagent = target.find({ name: 'activeagent' });
    var lastagent = target.find({ name: options.lastKey });
    var nextagent = target.find({ name: options.nextKey });
    return new TimelineMax()
      .to(nextagent, 0.5, { opacity: 1 })
      .to(lastagent, 0.5, { opacity: 0.7 }, '-=0.5')
      .to(bigagent, 0.5, { opacity: 0 })
      .call(options.func, [options.obj, options.THIS])
      .to(bigagent, 0.5, { opacity: 1 });
  }

  showFirst({ target, options }) {
    var agent = target.find({ name: options.agentID });
    return new TimelineMax().set(agent, { opacity: 1 });
  }

  newAgent(obj) {
    var options = {
      func: this.setAgent,
      THIS: this,
      nextKey: obj.id,
      lastKey: parseInt(this.state.firstagent.key, 10),
      obj: obj,
    };
    this.anim = this.addAnimation(this.hideAgent, options);
  }

  componentDidMount() {
    axios
      .get(back + '/allagents/?format=json')
      .then((res) => {
        const firstagent = res.data.flatMap((agent) =>
          (this.props.type === 'management' &&
            agent.position.toLowerCase() === 'management') ||
          (this.props.type !== 'management' &&
            agent.position.toLowerCase() !== 'management')
            ? [<ActiveAgent obj={agent} key={agent.id} />]
            : []
        );
        const img = res.data.map((obj) => (
          <img
            alt={obj.id}
            className="hidden"
            src={obj.prof_img.big}
            key={obj.id}
          />
        ));

        this.setState({ firstagent });

        this.setState({ imgs: img });
      })
      .then((res) => {
        var options = { agentID: parseInt(this.state.firstagent.key, 10) };
        this.anim = this.addAnimation(this.showFirst, options);
      });
  }

  render() {
    return (
      <div className="contactWrapper">
        <div className="contactContainer">
          <Row className="contact">
            <Title title="contact" color="grey" />
            <Row>{this.state.firstagent}</Row>
            {/* {this.state.imgs} */}
          </Row>
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/main/Contact.js